/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".no-transform[_ngcontent-%COMP%]{text-transform:none}.fixed-header[_ngcontent-%COMP%]{width:100%}"];
export { styles as styles };
